(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-circles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('circles-row-slider')) {
    class CirclesRowSlider extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-circles-scroller]');
        this.prevButton = this.querySelector('[data-circles-prev]');
        this.nextButton = this.querySelector('[data-circles-next]');
        if (!this.scroller || !this.prevButton || !this.nextButton) return;

        this.onScroll = this.updateNav.bind(this);
        this.onPrev = this.move.bind(this, -1);
        this.onNext = this.move.bind(this, 1);

        this.prevButton.addEventListener('click', this.onPrev);
        this.nextButton.addEventListener('click', this.onNext);
        this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('matchSmall', this.onScroll);
        document.addEventListener('unmatchSmall', this.onScroll);
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.toggleButton(this.prevButton, false);
        this.toggleButton(this.nextButton, true);
        requestAnimationFrame(() => this.updateNav());
      }

      disconnectedCallback() {
        if (!this.scroller) return;
        this.prevButton.removeEventListener('click', this.onPrev);
        this.nextButton.removeEventListener('click', this.onNext);
        this.scroller.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('matchSmall', this.onScroll);
        document.removeEventListener('unmatchSmall', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      move(direction) {
        const item = this.scroller.querySelector('.collection-circles__item');
        if (!item) return;

        const list = this.scroller.querySelector('.collection-circles__list');
        const styles = list ? window.getComputedStyle(list) : null;
        const gap = styles ? parseFloat(styles.columnGap || styles.gap) || 0 : 0;
        const rtl = window.theme && theme.config.rtl;
        const reduced = window.theme && theme.config.motionReduced;
        const distance = (item.getBoundingClientRect().width + gap) * direction * (rtl ? -1 : 1);

        this.scroller.scrollBy({
          left: distance,
          behavior: reduced ? 'auto' : 'smooth'
        });
      }

      updateNav() {
        if (!window.matchMedia('(max-width: 767px)').matches) {
          this.toggleButton(this.prevButton, false);
          this.toggleButton(this.nextButton, false);
          return;
        }

        const first = this.scroller.querySelector('.collection-circles__item');
        const last = this.scroller.querySelector('.collection-circles__item:last-child');
        if (!first || !last) return;

        const scrollerRect = this.scroller.getBoundingClientRect();
        const firstRect = first.getBoundingClientRect();
        const lastRect = last.getBoundingClientRect();
        const threshold = 16;
        const hasScrolled = firstRect.left < scrollerRect.left - threshold;
        const canScrollMore = lastRect.right > scrollerRect.right + threshold;

        this.toggleButton(this.prevButton, hasScrolled);
        this.toggleButton(this.nextButton, canScrollMore);
      }

      toggleButton(button, visible) {
        button.classList.toggle('is-visible', visible);
        button.hidden = !visible;
        button.setAttribute('aria-hidden', visible ? 'false' : 'true');
        button.tabIndex = visible ? 0 : -1;
      }
    }

    customElements.define('circles-row-slider', CirclesRowSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
